import React from 'react';
import { cn } from './cn';

export type FormRowProps = {
  label: React.ReactNode;
  hint?: React.ReactNode;
  error?: React.ReactNode;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
};

export function FormRow({ label, hint, error, required, children, className }: FormRowProps) {
  return (
    <label className={cn('block', className)}>
      <div className="flex items-baseline justify-between gap-3">
        <span className="text-sm font-medium text-text-primary">
          {label} {required ? <span className="text-negative">*</span> : null}
        </span>
        {hint ? <span className="text-xs text-text-muted">{hint}</span> : null}
      </div>
      <div className="mt-1.5">{children}</div>
      {error ? <div className="mt-2 text-sm text-negative">{error}</div> : null}
    </label>
  );
}

